import React from "react";
import "./styles.css";

export const Title = () => {
  return(
    <h1 className="Title">With Love</h1>
  )
}